import IPlainPartExchange from '../model/IPlainPartExchange';
import { ValuationPriceTypes } from '../enum/ValuationPriceTypes';
import { PartExchangeStatuses } from '../enum/PartExchangeStatuses';
import IPlainPriceEvaluationInterface from '../model/IPlainPriceEvaluationInterface';

const partExchangeTransformer = {
  extractValuationPrice(data: IPlainPartExchange): number {
    if (data.status === PartExchangeStatuses.BLOCKED || !data.valuation.priceEvaluations) {
      return 0;
    }

    const outstandingPrice = data.valuation.outstandingFinanceValue ?? 0;
    const finalPrice = data.valuation.priceEvaluations.find(
      (price: IPlainPriceEvaluationInterface) => price.evaluationType === ValuationPriceTypes.FINAL,
    );

    if (finalPrice && finalPrice.evaluationValue - outstandingPrice >= 0) {
      return finalPrice.evaluationValue - outstandingPrice;
    }

    const wholesalePrice = data.valuation.priceEvaluations.find(
      (price: IPlainPriceEvaluationInterface) => price.evaluationType === ValuationPriceTypes.WHOLESALE,
    );

    if (wholesalePrice.evaluationValue) {
      return wholesalePrice.evaluationValue;
    }
  },

  getCurrentValuation(valuations: IPlainPartExchange[], currentValuationId: string): IPlainPartExchange | null {
    return valuations.find(valuation => valuation.token === currentValuationId);
  },
};

export default partExchangeTransformer;
